import script from "./AdminAffiliates.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAffiliates.vue?vue&type=script&setup=true&lang=js"

import "./AdminAffiliates.vue?vue&type=style&index=0&id=679fc9ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-679fc9ec"]])

export default __exports__